import React, { useCallback, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as AppActions from "../stores/app/actions";
import { TRANSACTION_STATE, PAYMENT_METHOD } from '../constants/status';
import { extractUrlParams, isTransactionPending } from "../utils/common";
import LoadingSpin from "../components/LoadingSpin";
import { datadogLogs } from '@datadog/browser-logs';

export const VerificationPage = () => {
  const { code, 'merchant-return-url': merchantReturnUrl, timestamp } = extractUrlParams(window.location.href);
  const dispatch = useDispatch();
  const appStore = useSelector((store) => store, shallowEqual).app;
  const { transactionState, paymentMethod, redirectUrl } = appStore;
  const navigate = useNavigate();
  const transactionStatusInterval = 2000;

  const handleOBVFlow = useCallback(
    (status) => {
      datadogLogs.logger.info(`Handle verification flow: {code: ${code}, transaction state: ${status}}`, {});
      switch (status) {
        case TRANSACTION_STATE.NONE:
          dispatch(
            AppActions.setParams({ code, merchantReturnUrl }),
          );
          return dispatch(
            AppActions.transactionStatus(timestamp),
          );
        case TRANSACTION_STATE.WAITING_FOR_VERIFICATION:
          if ( redirectUrl ) {
            window.location.href = redirectUrl;
          } else {
            return navigate("/transactionError");
          }
          break;
        case TRANSACTION_STATE.VERIFIED:
        case TRANSACTION_STATE.PAYMENT_PROCESSING:
          if (paymentMethod === PAYMENT_METHOD.RFP) {
            return navigate("/rfp");
          }
          return;
        case TRANSACTION_STATE.SUCCESS:
          return navigate("/transactionSuccess");
        case TRANSACTION_STATE.FAILED:
          return navigate("/transactionError");
        default:
          return true;
      }
    },
    [navigate, dispatch, code, merchantReturnUrl, redirectUrl, paymentMethod, timestamp],
  );

  useEffect(() => {
    handleOBVFlow(transactionState);
  }, [transactionState, handleOBVFlow]);


  // Fetch the transaction status in two second intervals
  useEffect(() => {
    if (transactionState === TRANSACTION_STATE.NONE) {
      return;
    } else if (isTransactionPending(transactionState)) {
      const interval = setInterval(() => {
        return dispatch(
          AppActions.transactionStatus(timestamp),
        );
      }, transactionStatusInterval);
      return () => clearInterval(interval);
    }
  }, [transactionState, dispatch, timestamp])

  // Show error page after the retry period times out
  useEffect(() => {
    if (transactionState === TRANSACTION_STATE.SUCCESS) {
      return navigate("/transactionSuccess")
    } else if (!isTransactionPending(transactionState)) {
      return;
    }

  }, [transactionState, navigate])

  return (
    <div>
      <LoadingSpin />
    </div>
  );
};

VerificationPage.propTypes = {};

VerificationPage.defaultProps = {};

export default VerificationPage;
